<template>
  <ValidationProvider
    :vid="vid"
    :name="$attrs.name || $attrs.label"
    :rules="rules"
    v-slot="{ errors, validated, valid }"
  >
    <b-field
      v-bind="$attrs"
      :type="{
        'is-danger': errors[0] && showError,
        'is-success': validated && valid && showSuccess,
      }"
      :message="errors"
      class="validator-field"
      :class="fieldClass"
    >
      <b-input
        :value="displayedValue"
        @input="setInnerValue"
        v-bind="$attrs"
        @blur="blur"
        ref="innerInput"
      ></b-input>
    </b-field>

    <slot></slot>
  </ValidationProvider>
</template>

<script>
import { maskValue } from "../utils/util";

export default {
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      required: true,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    mask: {
      type: String,
      required: false,
    },
    showSuccess: {
      type: Boolean,
      default: true,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    allowSpace: {
      type: Boolean,
      default: false,
    },
    fieldClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      innerValue: null,
    };
  },
  computed: {
    displayedValue() {
      let maskedValue = maskValue(this.mask, this.innerValue);

      let innerInput = this.$refs.innerInput;
      if (innerInput != null) {
        innerInput.updateValue(maskedValue);
      }

      return maskedValue;
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue() {
      if (this.innerValue || this.innerValue === 0) {
        this.$emit("input", this.innerValue);
      }
    },
    // Handles external model changes.
    value: {
      immediate: true,
      handler: function (newVal) {
        this.innerValue = newVal;
      },
    },
  },
  methods: {
    blur() {
      this.$emit("blur", this.innerValue);
    },
    setInnerValue(value) {
      if (value || value === 0) {
        if (/^(?=.*\d)[\d ]+$/.test(value)) {
          this.innerValue = value.replace(/\s/g, "");
        } else {
          this.innerValue = value;
        }
      } else {
        this.innerValue = null;
      }
    },
    forceUpdate(value) {
      // Brute force the new value via $ref if the watcher is unable to pick up new changes
      this.innerValue = value;
    },
  },
};
</script>
